// Centralized links for the whole landing page.
// Real values live in links.json, written directly by the backend when
// pressing "Guardar cambios en el proyecto" in /content-admin.
import data from "./links.json";

export const WHATSAPP_NUMBER = data.whatsappNumber;
export const LINKS = data.links;
export const SITE_DOMAIN = data.siteDomain;
